const PUBLIC_API_URL = import.meta.env.VITE_PUBLIC_API_URL
const API_URL = PUBLIC_API_URL
  ? `${PUBLIC_API_URL}/api/v1/`
  : import.meta.env.VITE_PUBLIC_IS_PROD === 'TRUE'
  ? 'https://app.humblytics.com/api/v1/'
  : import.meta.env.VITE_PUBLIC_IS_LOCAL === 'TRUE'
  ? 'http://localhost:3000/api/v1/'
  : 'https://humblytics.onrender.com/api/v1/'

export function track(
  eventType: string,
  token?: string | null,
  props?: Record<string, unknown>
): void {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  if (token) headers['Authorization'] = `Bearer ${token}`
  fetch(API_URL + 'track', {
    method: 'POST',
    headers,
    body: JSON.stringify({ eventType, props }),
    keepalive: true,
  }).catch(() => {})
}
